<template>
  <v-container class="featured-section">
    <v-layout align-center class="section-padding clickable" @click="$router.push({ name: routeNames.activity_reservations.name })">
      <div class="icon__background flex-none">
        <v-img v-if="iconURL" height="24" width="24" :src="iconURL" contain></v-img>
        <v-icon v-else color="primary lighten-1">{{ icon }}</v-icon>
      </div>
      <v-flex class="text-color__dark H3 px-2">{{title}}</v-flex>
      <v-chip v-if="!loading && reservations.length" small class="page-chip white" color="primary lighten-1">
        <div>{{ $t('activity_reservation.actions.see_all') }}</div>
        <v-icon small class="material-symbols-rounded ml-2">arrow_forward</v-icon>
      </v-chip>
    </v-layout>
    <div class="featured-page__container py-2">
      <v-layout v-if="loading" justify-center align-center>
        <v-progress-circular indeterminate />
      </v-layout>
      <featured-reservation-summary
        v-else
        v-for="reservation in reservations"
        :reservation="reservation"
        :key="reservation.reservation.id"
        class="ma-2"
      />
      <div v-if="!loading && !reservations.length" class="ml-10">
        <div class="H1 grey-1-b--text">{{ $t('activity_reservation.no_upcoming_reservations') }}</div>
        <v-chip @click="$router.push({ name: routeNames.activity_reservations.name })" class="light-background primary--text text--lighten-1 mt-3 interactive-chip">
          <span class="mr-2">{{ $t('activity_reservation.actions.see_past_reservations') }}</span>
          <v-icon size="22" color="primary lighten-1 material-symbols-rounded">arrow_forward</v-icon>
        </v-chip>
      </div>
      <see-all v-if="!loading && reservations.length && hasMoreReservations"/>
    </div>
  </v-container>
</template>

<script>
import routeNames from '@/router/routes'
import { getTextValue } from '@/lib/helpers/LocalizedText'
import { mapGetters } from 'vuex'
import { cardAppearanceTypes, activityReservationStatus } from '@/config'
import { ActivityReservationsRequests } from '@/services/activityReservations.requests'
const activityReservationsService = new ActivityReservationsRequests()

export default {
  props: {
    page: Object,
  },
  data () {
    return {
      routeNames,
      cardAppearanceTypes,
      reservations: [],
      loading: true,
      hasMoreReservations: false,
      filterByStatus: [ 
        activityReservationStatus.PENDING, 
        activityReservationStatus.ACCEPTED, 
        activityReservationStatus.PENDING_MODIFICATION,
        activityReservationStatus.ACCEPTED_BY_ACTIVITY_MODIFICATION,
        activityReservationStatus.PENDING_PAYMENT,
      ],
    }
  },
  mounted () {
    this.getReservations()
  },
  methods: {
    getReservations () {
      this.loading = true
      activityReservationsService
        .listReservations({
          limit: 10,
          offset: 0,
          status: this.filterByStatus,
          orderBy: 'ASC',
        })
        .then(async (response) => {
          this.reservations.push.apply(
            this.reservations,
            response.reservations
          )
          this.hasMoreReservations = response.hasNext
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  computed: {
    ...mapGetters({ 
      authStatus: 'auth/authStatus',
      cardAppearance: 'service/getCardAppearance',
      authToken: 'auth/authToken',
    }),
    icon () {
      let icon = null
      if (this.page) {
        icon = this.page.icon
      }
      if (!icon) {
        icon = 'mdi-menu'
      }
      return icon
    },
    iconURL () {
      let icon = null
      if (this.page) {
        icon = this.page.iconUrl
      }
      return icon
    },
    title () {
      let title = null
      if (this.page) {
        title = getTextValue(this.page.title)
      }
      return title
    },
  },
  components: {
    FeaturedReservationSummary: () => import('@/components/view-components/webapp-pages/featured-reservations/FeaturedReservationSummary.vue'),
    SeeAll: () => import('@/components/view-components/webapp-pages/featured-reservations/SeeAll.vue'),
  },
}
</script>